import { Branch } from "./branch";
import { MultiSelectionMode } from "./multi-selection-mode";
import { MultiTreeItemSubselect } from "./multi-tree-item-subselect";
import { MultiSelectionModeDelegate, TreeSelection } from "./tree-select";
import { AbstractTreeSelectController } from "./tree-select-controller";

export class MultiTreeSelectController extends AbstractTreeSelectController implements MultiSelectionModeDelegate<MultiTreeItemSubselect> {

    private treeSelect: MultiSelectionMode|null = null;

    getValue(): string[][] {
        if (!this.treeSelect) {
            return [];
        }

        return this.treeSelect.value.map(branch => branch.values);
    }

    setValue(value: string[][]): void {
        if (!this.treeSelect) {
            return;
        }

        const branches = Array.isArray(value)
            ? value
                .filter((path): path is string[] => Array.isArray(path))
                .map(path => Branch.fromValues(path))
            : [];

        this.treeSelect.value = branches;
    }

    appendData(form: FormData) {
        let name = this.getName();
        this.treeSelect?.value.forEach((branch, index) => 
            branch.values.forEach((value) => 
                form.append(name + `[${index}][]`, value)
        ));
    }

    connect(): void {
        this.initializeHydrator();
        this.settings = { ...this.settings, multiple: true };

        this.hydrator?.hydrateBranch(this.element).then(branch => {
            const root = branch[0];
            if (!root) {
                throw new Error('Multi tree select requires a root subselect');
            }

            this.treeSelect = new MultiSelectionMode(this.element, this, root);
            this.treeSelect.connect();

            // Register any pre-rendered subselect under the root
            // Supports the use case of top-level tab navigation with the first tab preselected 
            const preselection = root instanceof MultiTreeItemSubselect ? null : root.value;
            const preloadedSubselect = branch[1];
            if (preselection && preloadedSubselect instanceof MultiTreeItemSubselect) {
                this.treeSelect.registerSubselect(preloadedSubselect, Branch.fromValues([preselection]));
            }
 
            super.connect();
        });
    }

    disconnect(): void {
        this.treeSelect?.disconnect();
        this.treeSelect = null;
        super.disconnect();
    }

    getSubselect(context: TreeSelection): Promise<MultiTreeItemSubselect | null> {
        return this.loadSubselect(context, (subselect): subselect is MultiTreeItemSubselect => {
            return subselect instanceof MultiTreeItemSubselect;
        });
    }
}
